import { useEffect, useState } from "react"
import { TranslationsStringsType } from "../../models/enum/rsvpEnum"
import { RsvpDetails, Settings, StepsTranslations } from "../../models/api/rsvpApiTypes"
import { useAppSelector } from "../../hook/useReduxHooks"
import { RootState } from "../../redux/store"
import { resolveTranslation } from "../../utils/translations"
import RsvpBox from "../RsvpBox"
import StepRecap from "./StepRecap"
import resultStepIcon from "../../icon/result-icon.svg"

interface StepRecapBoxProps {
  settings: Settings
  rsvp: RsvpDetails
  tenant: string
  reservationCode: string
  stepPipeline: string[]
  setStep: (name: string) => void
}

export default function StepRecapBox({
  settings,
  rsvp,
  stepPipeline,
  tenant,
  reservationCode,
  setStep,
}: StepRecapBoxProps) {
  const [recapStrings, setRecapStrings] = useState<StepsTranslations | undefined>({
    lang: "",
    strings: [],
  })
  const language = useAppSelector((state: RootState) => state.languageReducer.language).toLocaleLowerCase()

  useEffect(() => {
    const newRecapStrings =
      resolveTranslation(settings.steps?.find((x) => x.name === "summary")?.translations ?? [], language)
    setRecapStrings(newRecapStrings)
  }, [language, settings.steps])

  return (
    <div className="box">
      <RsvpBox
        iconAlt="resultStepIcon"
        iconSource={resultStepIcon}
        title={recapStrings?.strings.find((x) => x.type === TranslationsStringsType.TITLE)?.value}
        description={recapStrings?.strings.find((x) => x.type === TranslationsStringsType.DESCRIPTION)?.value}
      >
        <StepRecap
          buttonColor={settings.rsvpStyle.buttonColor === null ? "#0c6efb" : settings.rsvpStyle.buttonColor}
          backButtonColor={settings.rsvpStyle.backButtonColor === null ? "#a6b7d4" : settings.rsvpStyle.backButtonColor}
          strings={recapStrings?.strings}
          rsvp={rsvp}
          stepPipeline={stepPipeline}
          setStep={setStep}
          tenant={tenant}
          reservationCode={reservationCode}
        />
      </RsvpBox>
    </div>
  )
}
